export default __webpack_public_path__ + "static/media/grafema_SET_19.91e8c515.jpg";